import api from '@/services/api'

export default {
  state: {},

  mutations: {},

  actions: {
    async getReportsByCnpj({ commit }, cnpj) {
      try {
        const params = new URLSearchParams(cnpj)

        const response = await api.get(`/ethos/reports/cnpj?${params}`)
        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },

    async getReports({ commit }) {
      try {
        const response = await api.get('/ethos/reports')
        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },

    async getReportsByCompany({ commit }) {
      try {
        const response = await api.get('/company/reports')
        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },

    async getReportByHash({ commit }, hash) {
      try {
        const params = new URLSearchParams(hash)

        const response = await api.get(`/company/reports/hash?${params}`)
        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },
  },

  getters: {},
}
